import Socials from "./Socials";

export default Socials;
